/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.header_mob", {
        options: {},
        _create: function () {
            const self = this;

            self.elem = self.element;

            self.iniMobMenu();
            self.onScrollmenu();

            $(document).on("window-resized", () => {
                $("body").removeClass("mob-menu-open");
            });
        },

        iniMobMenu: function () {
            const self = this;

            $(".header-mob__burger").on("click", function () {
                if (!$("body").hasClass("mob-menu-open")) {
                    self.openMobMenu();
                    $(".header__logo img").addClass("sml-logo");
                    self.elem.find(".header-mob__bar").addClass("wht-bg");
                } else {
                    if (!$("body").hasClass("menu-opened")) {
                        $(".header__logo img").removeClass("sml-logo");
                    }

                    self.closeMobMenu();
                    self.elem.find(".header-mob__bar").removeClass("wht-bg");
                }
            });

            // $(window).on('resize', function () {
            //     if (api.winW >= 768) {
            //         self.closeMobMenu()
            //     }
            // })
        },

        openMobMenu: function () {
            $("body").addClass("mob-menu-open");
            api.fn.disableBodyScroll();
            $("body").css("top", "0");
        },

        closeMobMenu: function () {
            $("body").removeClass("mob-menu-open");
            $("nav > ul > li > a ").removeClass("is-open");
            $(".header-mob__menu__submenu").removeClass("is-open").slideUp();
            $(".header-mob__menu__sub li a span").removeClass("is-open");
            $(".header-mob__menu__sub").slideUp();
            api.fn.enableBodyScroll();
        },

        //customise on scroll header with white bg and change logo height
        onScrollmenu: function () {
            var plgn = this;

            jQuery(window).scroll(function () {
                if (jQuery(window).scrollTop() >= 50) {
                    $(".header-mob__logo img").addClass("sml");
                    $(".header-mob__bar").addClass("wht-bg");
                } else {
                    $(".header-mob__logo img").removeClass("sml");
                    $(".header-mob__bar").removeClass("wht-bg");
                }
            });
        },
    });
})(jQuery);
